import type { ReactNode } from "react";
import { Skeleton, Grid } from "@mui/material";

export function LoadingTableCell(): ReactNode {
  return (
    <Grid size={2}>
      <Skeleton />
    </Grid>
  );
}
